/* eslint-disable import/prefer-default-export */
const getGlobalState = (state, key) => (Array.isArray(state.marketSettings[key]) ? state.marketSettings[key].slice(0) : state.marketSettings[key]);

export const marketSettings = (state) => getGlobalState(state, 'marketSettings');
export const tennisMarketSettings = (state) => getGlobalState(state, 'tennisMarketSettings');
export const getPrematchMarkets = (state) => getGlobalState(state, 'prematchMarkets');
